import React from "react";

const NoChatRoomsFound = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h3> No chat rooms found </h3>
    </div>
  );
};

export default NoChatRoomsFound;
